import { useListGraphEntities } from '@squareup/dex-feature-hooks-graph';
import { EntityPageContent } from '@squareup/dex-tech-entity-page-content';
import { getNextPublicApiReferenceNameOrDefault } from '@squareup/dex-utils-environment';
import {
  filterForValidGraphEntityObjects,
  isWebhookObject,
} from '@squareup/dex-utils-oas';
import { useParams } from '@squareup/dex-utils-shared-routing-hooks';
import React, { ReactNode, useMemo } from 'react';

import { SquareVersionPage } from '../../../../shared/SquareVersionPage';

const PageContent = () => {
  const { entities } = useListGraphEntities();
  const params = useParams();

  const filteredEntities = useMemo(() => {
    return filterForValidGraphEntityObjects(entities).filter(
      (obj) => !isWebhookObject(obj)
    );
  }, [entities]);

  const title = `Objects Index - ${getNextPublicApiReferenceNameOrDefault()}`;

  return (
    <EntityPageContent
      description="List of all objects in the Square API."
      entities={filteredEntities}
      title={title}
      type="object"
      currentVersion={params?.square_version as string}
    />
  );
};

class Page extends SquareVersionPage {
  public static override routeHandlerName = '[square_version]/objects';

  protected override getPageContent(): ReactNode {
    return super.getPageContent({
      children: <PageContent />,
    });
  }
}

export default Page;
